'use client';

import React from 'react';
import styles from '$modules/onboarding/module-components/onboarding/commom.module.scss';
import { Button, Icon, validIcons, ButtonSize, ButtonType, Toast, Loader, Input, SubHeader } from '@brahma/components';
import { useLogin } from '$modules/onboarding//hooks/use-login';
const LoginWeb = () => {
  const {
    t,
    showBadge,
    showPassword,
    submitClicked,
    values,
    errors,
    loading,
    routerLoading,
    loginData,
    handleChange,
    onSubmit,
    handleForgotPassword,
    togglePasswordVisibility
  } = useLogin();
  return <div className={styles.parentContainer} data-sentry-component="LoginWeb" data-sentry-source-file="log-in.web.tsx">
      <Loader show={loading || routerLoading} data-sentry-element="Loader" data-sentry-source-file="log-in.web.tsx" />
      <div className={styles.subHeaderLarge}>
        <SubHeader iconName={validIcons.checkMarkShadow} title={t('login.loginTitle')} description={t('login.loginDescription')} iconClassName={styles.iconSubheader} iconWidth="120px" baseUrl={process.env.NEXT_PUBLIC_STATIC_URL ?? ''} background="gridDotLg" data-sentry-element="SubHeader" data-sentry-source-file="log-in.web.tsx" />
      </div>
      <div className={styles.mainContainer}>
        <Input placeholder={t('login.emailPlaceholder')} onChange={handleChange} type="email" label={t('login.emailLabel')} value={values.email} name="email" errorMessage={submitClicked && errors.email} data-testid="inputBox" prefixIcon={<Icon iconName={validIcons.mail01} />} data-sentry-element="Input" data-sentry-source-file="log-in.web.tsx" />
        <Input placeholder={t('login.passwordPlaceholder')} onChange={handleChange} label={t('login.passwordLabel')} name="password" type={showPassword ? 'text' : 'password'} data-testid="password-inputBox" suffixIcon={<Icon iconName={validIcons.eye} onClick={togglePasswordVisibility} />} errorMessage={submitClicked && errors.password} data-sentry-element="Input" data-sentry-source-file="log-in.web.tsx" />
        <div className={styles.forgotPassword}>
          <Button text={t('login.forgotButton')} variant="link" size={ButtonSize.Large} className={styles.forgotButton} onClick={handleForgotPassword} testPrefixId="forgot" data-sentry-element="Button" data-sentry-source-file="log-in.web.tsx" />
        </div>
        <div className={styles.buttonContainer}>
          <Button text={t('login.loginButton')} variant={ButtonType.Primary} size={ButtonSize.Large} className={styles.button} onClick={onSubmit} disabled={loading} testPrefixId="login" data-sentry-element="Button" data-sentry-source-file="log-in.web.tsx" />
        </div>
      </div>

      {showBadge ? <Toast content={loginData?.message ?? ''} variant={loginData?.code === 200 ? 'success' : 'error'} /> : null}
    </div>;
};
export default LoginWeb;